var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Android",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 44,
    viewBox: "0 0 140 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.297,
    y1: -0.06,
    x2: 0.552,
    y2: 0.928,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ad1d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.077,
    y1: 0.161,
    x2: 0.916,
    y2: 0.865,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24bbb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1.051,
    x2: 0.5,
    y2: -0.045,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcc072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a5b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.109,
    y1: 1.176,
    x2: 0.905,
    y2: 0.115,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#712b8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea1d27"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5417",
    "data-name": "Path 5417",
    d: "M135.625,44H4.375A4.386,4.386,0,0,1,0,39.6V4.4A4.386,4.386,0,0,1,4.375,0h131.25A4.386,4.386,0,0,1,140,4.4V39.6A4.386,4.386,0,0,1,135.625,44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5418",
    "data-name": "Path 5418",
    d: "M9.77,20.815V9.2A1.243,1.243,0,0,1,10.9,7.97a1.852,1.852,0,0,1,1.039.3L33.045,19.921a1.112,1.112,0,0,1,.678.906,1.09,1.09,0,0,1-.678.906L11.936,33.384a1.953,1.953,0,0,1-1.039.287A1.234,1.234,0,0,1,9.77,32.446Z",
    transform: "translate(0.916 0.747)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5419",
    "data-name": "Path 5419",
    d: "M23.405,20.768,10.63,7.982a1.205,1.205,0,0,1,.2-.022,1.865,1.865,0,0,1,1.039.3l15.553,8.5Z",
    transform: "translate(0.997 0.817)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5420",
    "data-name": "Path 5420",
    d: "M26.226,23.93,22.31,20.014,26.324,16l5.556,3.041a1.1,1.1,0,0,1,.678.9,1.081,1.081,0,0,1-.678.9Z",
    transform: "translate(2.092 1.622)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5421",
    "data-name": "Path 5421",
    d: "M10.75,32.314l.011-.011L23.394,19.67l3.916,3.916L11.855,32.029a1.968,1.968,0,0,1-1.039.284A.07.07,0,0,1,10.75,32.314Z",
    transform: "translate(1.008 2.017)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5422",
    "data-name": "Path 5422",
    d: "M74.167,35.346a6.2,6.2,0,0,1-1.214-1.663l1.761-.755a3.481,3.481,0,0,0,.536.831,2.407,2.407,0,0,0,1.794.831,2.367,2.367,0,0,0,1.859-.875,3.117,3.117,0,0,0,.5-1.838V31.19c-1.258,1.619-4.014,1.389-5.545-.284a4.865,4.865,0,0,1,.033-6.486c1.641-1.63,4.08-1.837,5.513-.3h0v-.766H81.32v8.3a4.571,4.571,0,0,1-1.739,4,4.491,4.491,0,0,1-2.559.744,4.288,4.288,0,0,1-2.855-1.061Zm45.773.448h0l1.848-4.364-3.259-7.569h1.859l2.33,5.392,2.275-5.392h1.859l-5.042,11.944h-1.87Zm-8.827-4.167h0a2.949,2.949,0,0,1-.82-2.023,2.535,2.535,0,0,1,.678-1.783,4.1,4.1,0,0,1,3.052-1.148,3.971,3.971,0,0,1,1.969.448,1.8,1.8,0,0,0-1.925-1.848,1.854,1.854,0,0,0-1.816,1.181l-1.673-.678a3.444,3.444,0,0,1,3.445-2.188,3.553,3.553,0,0,1,3.773,4v4.583H115.97v-.82a3.116,3.116,0,0,1-1,.787,3.5,3.5,0,0,1-1.52.306,3.324,3.324,0,0,1-2.341-.82ZM52.85,27.679h0a4.55,4.55,0,1,1,4.55,4.594,4.546,4.546,0,0,1-4.55-4.594Zm9.877,0h0a4.55,4.55,0,1,1,4.55,4.594,4.546,4.546,0,0,1-4.55-4.594ZM40.524,30.1h0A7.1,7.1,0,0,1,40.6,20.088a7.054,7.054,0,0,1,9.855-.142l-1.367,1.422a4.968,4.968,0,0,0-7.044.1A5.279,5.279,0,0,0,42,28.773a5.027,5.027,0,0,0,7.2.12,4.232,4.232,0,0,0,1.028-2.45H45.61V24.5H52.1a8.514,8.514,0,0,1,.109,1.487,6.263,6.263,0,0,1-6.519,6.3A7.506,7.506,0,0,1,40.524,30.1Zm46.189.82h0a4.968,4.968,0,0,1,0-6.508,3.99,3.99,0,0,1,5.961-.011,7.053,7.053,0,0,1,1.17,2.111l-6.07,2.559a2.364,2.364,0,0,0,2.155,1.4,2.5,2.5,0,0,0,2.264-1.28l1.586,1.072h0c-.186.241-.4.481-.58.667a4.591,4.591,0,0,1-6.486-.011Zm11.4,1.28h0V20.11H102a3.865,3.865,0,0,1,4.112,3.664,3.712,3.712,0,0,1-3.752,3.664H99.958v4.769H98.11Zm9.209,0h0V20.11h1.848v12.1h-1.848Zm-24.7-.2h0V18.469h2.023V32Zm33.37-3.347h0a3.271,3.271,0,0,0-1.739-.448c-1.312,0-2.056.667-2.056,1.389a1.347,1.347,0,0,0,1.5,1.214,2.3,2.3,0,0,0,2.3-2.155Zm-56.055-.973h0A2.547,2.547,0,1,0,57.4,30.446a2.649,2.649,0,0,0,2.537-2.767Zm9.877,0h0a2.547,2.547,0,1,0-2.537,2.767,2.649,2.649,0,0,0,2.537-2.767Zm9.647.842h0a2.118,2.118,0,0,0,.077-.328.113.113,0,0,1,.011-.044,2.322,2.322,0,0,0,.033-.481,2.179,2.179,0,0,0-.044-.459.133.133,0,0,0-.011-.055,2.428,2.428,0,0,0-.1-.4,2.473,2.473,0,0,0-2.33-1.816,2.786,2.786,0,0,0,.033,5.534,2.587,2.587,0,0,0,2.33-1.947Zm8.006-1.006h0L91.514,25.8a1.866,1.866,0,0,0-1.673-.952,2.556,2.556,0,0,0-2.373,2.669Zm16.767-3.708h0a1.936,1.936,0,0,0-2.067-1.914h-2.22v3.828h2.319A1.929,1.929,0,0,0,104.235,23.807Z",
    transform: "translate(3.609 1.938)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5423",
    "data-name": "Path 5423",
    d: "M114.251,32.262v-.011h0V32.24h-.011v.011Z",
    transform: "translate(10.71 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M114.272,32.262h0v-.011h-.022v.022h0v-.011Zm-.011-.022Z",
    transform: "translate(10.711 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M114.281,32.251h-.011V32.24h0v.022h.011Z",
    transform: "translate(10.713 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M114.3,32.262l-.011-.022h0l-.011.022h.022Zm-.011-.011Z",
    transform: "translate(10.714 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M114.311,32.24H114.3v.022h0V32.24Z",
    transform: "translate(10.716 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M114.321,32.251h-.011V32.24h0v.022h.011Z",
    transform: "translate(10.717 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M114.342,32.251h0c0-.011,0-.011-.011-.011h-.011v.022l.022-.011Zm-.011,0Z",
    transform: "translate(10.717 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M114.362,32.251h0c0-.011,0-.011-.011-.011h-.011v.022l.022-.011c-.011.011,0,.011,0,0Zm-.011-.011Zm0,.011Z",
    transform: "translate(10.719 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M114.371,32.24h0v0h-.011v.022h.011v-.011Z",
    transform: "translate(10.721 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M114.4,32.252h-.011V32.23h-.011v.033h.022Z",
    transform: "translate(10.723 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M114.422,32.252v-.011l-.011-.011a.011.011,0,0,0-.011.011v.011a.015.015,0,0,0,.022,0Zm-.011,0h0l-.011-.011h0v.011Z",
    transform: "translate(10.725 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M114.442,32.262V32.24h-.011v.011h0l.011.011h0l-.011-.011V32.24h0a.011.011,0,0,0-.011.011v.011c0-.011.011,0,.022,0Z",
    transform: "translate(10.727 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M114.462,32.252v-.011a.011.011,0,0,0-.022,0v.011a.015.015,0,0,0,.022,0Zm0,0h0l-.011-.011h0v.011Z",
    transform: "translate(10.729 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M114.5,32.263V32.23h0l-.011.022-.011-.022h0v.033h0v-.022h0l.011.022h0l.011-.022h0Z",
    transform: "translate(10.732 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M114.533,32.263l-.011-.033h-.011l-.011.033h.011v-.011l.022.011Zm-.011-.022Z",
    transform: "translate(10.734 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5438",
    "data-name": "Path 5438",
    d: "M114.552,32.251h0l-.011-.011h0c-.011,0-.011,0-.011.011a.011.011,0,0,0,.011.011c0-.022,0-.011.011-.011h-.011c-.011.011,0,.011.011,0Z",
    transform: "translate(10.737 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M114.572,32.23h-.011v.033h0V32.23Z",
    transform: "translate(10.739 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M114.592,32.252h-.022v-.011h0V32.23h0v.033h.022Z",
    transform: "translate(10.741 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M114.612,32.263l-.011-.011a.011.011,0,0,0,.011-.011h0c0-.011,0-.011-.011-.011h-.011v.033h0v-.011h0l.022.011Zm-.011-.022Z",
    transform: "translate(10.743 3.272)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M38.92,10.332A3.081,3.081,0,0,1,42.147,7.16a2.891,2.891,0,0,1,2.472,1.269l-.875.5a1.977,1.977,0,0,0-1.6-.82,2.1,2.1,0,0,0-2.122,2.22,2.114,2.114,0,0,0,2.122,2.22,2.173,2.173,0,0,0,1.455-.558v-.952H41.764V10.1h2.909v2.3a3.348,3.348,0,0,1-2.527,1.127A3.118,3.118,0,0,1,38.92,10.332Z",
    transform: "translate(3.649 0.724)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M45.4,13.386V7.25h4.211V8.2H46.483V9.788h3.063v.952H46.483v1.706h3.128V13.4L45.4,13.386Z",
    transform: "translate(4.256 0.732)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M52.129,13.386v-5.2H50.27V7.25h4.8V8.2H53.212v5.2H52.129Z",
    transform: "translate(4.713 0.732)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M58.08,13.386V7.25h1.072V13.4H58.08Z",
    transform: "translate(5.445 0.732)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M61.969,13.386v-5.2H60.11V7.25h4.8V8.2H63.052v5.2H61.969Z",
    transform: "translate(5.635 0.732)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M67.67,10.332a3.139,3.139,0,1,1,6.278,0,3.139,3.139,0,1,1-6.278,0Zm5.184,0a2.042,2.042,0,1,0-4.069,0,2.042,2.042,0,1,0,4.069,0Z",
    transform: "translate(6.344 0.724)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M78.847,13.386l-3.2-4.4v4.4H74.57V7.25h1.1L78.814,11.5V7.25H79.9V13.4h-1.05Z",
    transform: "translate(6.991 0.732)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.4656c72845ca6bf661ad7c1bddcff1ee.svg";
export { ForwardRef as ReactComponent };